export const datas = [
  ['苹果', 'AAPL'],
  ['谷歌A', 'GOOGL'],
  ['谷歌C', 'GOOG'],
  ['微软', 'MSFT'],
  ['亚马逊', 'AMZN'],
  ['脸书', 'FB'],
  ['强生', 'JNJ'],
  ['摩根大通', 'JPM'],
  ['埃克森美孚', 'XOM'],
  ['沃尔玛', 'WMT'],
  ['美国银行', 'BAC'],
  ['富国银行', 'WFC'],
  ['维萨卡VISA', 'V'],
  ['伯克希尔哈撒韦B', 'BRK.B'],
  ['宝洁', 'PG'],
  ['雪佛龙', 'CVX'],
  ['台积电', 'TSM'],
  ['英特尔', 'INTC'],
  ['辉瑞', 'PFE'],
  ['中国移动', 'CHL'],
  ['美国电话电报公司AT&T', 'T'],
  ['联合健康', 'UNH'],
  ['甲骨文', 'ORCL'],
  ['可口可乐', 'KO'],
  ['百事可乐', 'PEP'],
  ['花旗集团', 'C'],
  ['丰田汽车', 'TM'],
  ['威瑞森', 'VZ'],
  ['思科', 'CSCO'],
  ['迪士尼', 'DIS'],
  ['通用电气', 'GE'],
  ['万事达', 'MA'],
  ['波音', 'BA'],
  ['荷兰壳牌', 'RDS.A'],
  ['IBM', 'IBM'],
  ['麦当劳', 'MCD'],
  ['英国石油', 'BP'],
  ['英伟达', 'NVDA'],
  ['中石油', 'PTR'],
  ['必和必拓', 'BHP'],
  ['博通', 'AVGO'],
  ['高通', 'QCOM'],
  ['中国人寿', 'LFC'],
  ['耐克', 'NKE'],
  ['高盛', 'GS'],
  ['摩根士丹利', 'MS'],
  ['洛克希德马丁', 'LMT'],
  ['PayPal', 'PYPL'],
  ['Adobe', 'ADBE'],
  ['中石化', 'SNP'],
  ['斯伦贝谢', 'SLB'],
  ['美国运通', 'AXP'],
  ['力拓', 'RIO'],
  ['奈飞', 'NFLX'],
  ['星巴克', 'SBUX'],
  ['陶氏杜邦', 'DWDP'],
  ['沃达丰', 'VOD'],
  ['卡特彼勒', 'CAT'],
  ['贝莱德', 'BLK'],
  ['荷兰国际', 'ING'],
  ['时代华纳', 'TWX'],
  ['瑞银', 'UBS'],
  ['高露洁', 'CL'],
  ['巴西石油公司', 'PBR'],
  ['劳埃德银行', 'LYG'],
  ['通用汽车', 'GM'],
  ['中海油', 'CEO'],
  ['康菲石油', 'COP'],
  ['索尼', 'SNE'],
  ['美国国际集团', 'AIG'],
  ['雷神', 'RTN'],
  ['纽约梅隆银行', 'BK'],
  ['21世纪福克斯(B股)', 'FOX'],
  ['特斯拉', 'TSLA'],
  ['淡水河谷', 'VALE'],
  ['孟山都', 'MON'],
  ['雅虎（Altaba）', 'AABA'],
  ['Phillips 66', 'PSX'],
  ['动视暴雪', 'ATVI'],
  ['T-Mobile US', 'TMUS'],
  ['福特汽车', 'F'],
  ['保德信金融', 'PRU'],
  ['巴克莱银行', 'BCS'],
  ['eBay', 'EBAY'],
  ['中国电信', 'CHA'],
  ['旅行者保险', 'TRV'],
  ['德意志银行', 'DB'],
  ['哈利伯顿', 'HAL'],
  ['惠普', 'HPQ'],
  ['中国联通', 'CHU'],
  ['瓦莱罗能源', 'VLO'],
  ['黑石集团', 'BX'],
  ['达美航空', 'DAL'],
  ['艺电', 'EA'],
  ['塔吉特', 'TGT'],
  ['诺基亚', 'NOK'],
  ['穆迪', 'MCO'],
  ['百胜餐饮', 'YUM'],
  ['西部数据', 'WDC'],
  ['法拉利', 'RACE'],
  ['斯普林特', 'S'],
  ['富兰克林-邓普顿', 'BEN'],
  ['哥伦比亚广播公司', 'CBS'],
  ['纽蒙特矿业', 'NEM'],
  ['美高梅', 'MGM'],
  ['爱立信', 'ERIC'],
  ['纽柯钢铁', 'NUE'],
  ['赛门铁克', 'SYMC'],
  ['巴里克黄金', 'ABX'],
  ['智利矿业化工', 'SQM'],
  ['Twitter', 'TWTR'],
  ['蒂芙尼', 'TIF'],
  ['加拿大能源', 'ECA'],
  ['Cheniere Energy', 'LNG'],
  ['蔻驰', 'TPR'],
  ['中国铝业', 'ACH'],
  ['AMD公司', 'AMD'],
  ['香港恒生指数', 'HSI'],
  ['恒生国企指数', 'HSCEI'],
  ['恒生红筹指数', 'HSCCI']
]

export const priceOptionDatas = (() => {
  let items = {}
  datas.forEach(item => {
    items[item[1]] = {
      name: item[0],
      bValue: null,
      pValue: null,
      dir: '',
      bgColor: '',
      textColor: '',
      bTextColor: ''
    }
  })
  return items
})()

export const subscription = (() => {
  let items = []
  datas.forEach(item => {
    items.push(item[1])
  })
  return items
})()



// WEBPACK FOOTER //
// ./src/views/index/modules/Price/option.js